import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import { selectors as rootSelectors } from '../root';
import Table from './components/table/main';
import createForm from './components/poll-form/main';

const PollForm = createForm('pollForm');

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content polls-list">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Polls')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="ui-control-bar">
						<div className="ui-control-bar__item">
							<div className="ui-control-bar__item-position">
								{props.can('create') && (
									<button
										onClick={() => props.togglePollForm()}
										className="ui-btn ui-btn-primary ui-btn-sign__plus"
									>
										{props.intl('Create poll')}
									</button>
								)}
							</div>
						</div>
					</div>
					<Table {...props} />
					<PollForm {...props} enableReinitialize={true} initialValues={props.pollFormInitialValues} />
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		pagination: selectors.getPagination(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		pollFormInitialValues: selectors.getPollFormInitialValues(state),
		shouldShowPollForm: selectors.getShouldShowPollForm(state),
		isEditModePollForm: selectors.getPollFormEditMode(state),
		statusesList: selectors.getStatusesList(state),
		languagesList: selectors.getLanguagesList(state),
		progressBar: selectors.getProgressBar(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/polls/main.js